import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-16 md:py-24 bg-secondary-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-700 text-xs font-semibold uppercase tracking-wider mb-6">
            Community Trust
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight max-w-xl">
            What Our Community<br />Says About the <span className="text-primary-500">Vigorbuy Spreadsheet</span>
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={t.handle}
              className="break-inside-avoid bg-background-50 rounded-xl p-6 mb-5 md:mb-6 border border-background-200/50"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="font-semibold text-foreground-950 text-sm">{t.name}</p>
                  <p className="text-foreground-500 text-xs">{t.handle}</p>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}